export default __webpack_public_path__ + "static/media/M_wdt_c_cap_1.288fa599.mp3";